import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  contentContainerStyle: { paddingBottom: 160 },
  containerStyle: {
    paddingHorizontal: 16,
  },
  choosePlanText: {
    ...Fonts.type.bold,
    fontSize: 24,
    justifyContent: 'flex-start',
  },
  myCurrentPlanText: theme => ({
    fontSize: 16,
    marginVertical: 16,
    color: theme.colors.inActiveColorThree,
  }),
  sectionContainerStyle: { marginBottom: 18.3 },
  recommendedContainer: theme => ({
    width: 190,
    height: 32,
    borderTopLeftRadius: 6.2,
    borderTopRightRadius: 6.2,
    backgroundColor: theme.colors.activeColor,
    alignItems: 'center',
    justifyContent: 'center',
  }),
  recommendedText: theme => ({
    ...Fonts.type.bold,
    fontSize: 16.6,
    color: theme.colors.activeColorTwo,
  }),
  headerContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 32,
    marginBottom: 16,
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: 7,
  },
  buttonIcon: theme => ({
    tintColor: theme.colors.hyperlinkFive,
  }),
  buttonText: {
    fontSize: 16.7,
    marginRight: 4,
  },
  whyThisPlanModalHeader: {
    marginTop: 12,
    alignItems: 'center',
    marginHorizontal: 0,
  },
  whyThisPlanModalQuestion: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    marginTop: 30,
  },
  whyThisPlanModalContentText: {
    marginTop: 30,
    fontSize: 17,
    lineHeight: 24,
  },
  whyThisPlanModalButton: {
    marginTop: 30,
  },
});
